import { render, staticRenderFns } from "./UserRankList.vue?vue&type=template&id=f6f96556&scoped=true&"
import script from "./UserRankList.vue?vue&type=script&lang=js&"
export * from "./UserRankList.vue?vue&type=script&lang=js&"
import style0 from "./UserRankList.vue?vue&type=style&index=0&id=f6f96556&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f96556",
  null
  
)

export default component.exports